require('../helpers/css/next-gen-widget-iframe.css');
var FrameContainerNextGen = require('../helpers/FrameContainerNextGen');

var factory = {
    getFrameContainer: function (mode) {
        var container = new FrameContainerNextGen('ct-custom-read-review-widget', 'nextgen');
        if (mode) {
            container.mode = mode;
        }
        return container
    }
};

module.exports = factory;



/*****************
 ** WEBPACK FOOTER
 ** ./client/factories/iframe_next_gen_container_factory.js
 ** module id = 1
 ** module chunks = 0
 **/